import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';

const VERSION = 'v1';

const converter = {
  toFirestore(
    config: BonusRecordTagging.RecordTaggingConfig,
  ): firebase.firestore.DocumentData {
    return config;
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<BonusRecordTagging.RecordTaggingConfig>,
    options: firebase.firestore.SnapshotOptions,
  ): BonusRecordTagging.RecordTaggingConfig {
    return {
      ...snapshot.data(options),
    };
  },
};

// The whole set of exclusion configs for a program. Config doc ids are
// generated by getExclusionConfigDocId.
const getBonusRecordTaggingConfigsRef = ({
  accountId,
  bonusProgramId,
}: {
  accountId: string;
  bonusProgramId: string;
}) => {
  return firebase
    .firestore()
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.DRIVER_BONUS_EXCLUSION_GRIDS_CONFIG_COLLECTION)
    .doc(bonusProgramId)
    .collection(VERSION)
    .withConverter(converter);
};

export default getBonusRecordTaggingConfigsRef;
